'use strict';

var base = require('./carousels');

var einsteinObserver = require('einstein/components/einstein').einsteinObserver;
var baseProductTileCarousels = base.productTileCarousels;
var baseCartRecCarousels = base.cartRecProductCarousels;

/**
 * Add einstein observer to product tile carousel slots inside an element with an einstein-slot class
 */
base.productTileCarousels = function () {
    einsteinObserver('.einstein:not(.RecommendationsInsideCart), .tile-type-simple', baseProductTileCarousels);
};

base.baseCartRecCarousels = function () {
    einsteinObserver('.einstein.RecommendationsInsideCart', baseCartRecCarousels);
};

module.exports = base;
